import Web3 from "web3";


// ✅ Use MetaMask provider
const web3 = new Web3(window.ethereum);

// ✅ Your contract addresses
// const ITreasureContract = "0x45ec09B9c88b514Ea7C04a1E6EdB2057815393D7";

// const USDTContarct = "0x9d07dAC32d7c835E9daA1802Ced37e5Fc5F9F2aD";

// const NFTContarct = "0x894e9214258Bd71a7D4d331D2605712f07aaeC3F";
// const DepositContract = "0xFc80D265C8a1882ba2992f33969F3FabB4828b9f";


// const ReserveContract = "0xd866f12A6383044D2E5126e5EB44CBfd35Db54b6";
// const NFTDataContract = "0xd3Ab77c4eA46e316e4b4eF9E43A60209E975cC87";

const ITreasureContract = "0x4d533133220BCCeAd59Ef31450C298D7b8B27ACA";

const USDTContarct = "0x9e5AAC1Ba1a2e6aEd6b32689DFcF62A509Ca96f3";

const NFTContarct = "0x2BED3192fA64d9bbE5fFECC81a16e854165Dc0bb";
const DepositContract = "0xC78da462c2fC8E21D59aC5dA9d963CB173BA44a5";


const ReserveContract = "0x489792f11b38C5952Ef7a433B14285D547Dba747";
const NFTDataContract = "0x5547d8e2176E5595BBDb8052723270344e8D9eDb";




export { web3, ITreasureContract, USDTContarct,NFTContarct,ReserveContract,NFTDataContract,DepositContract };